// import { AppInfoStateType } from '@parent-app/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppInfoStateType, WebInfoStateType } from 'src/shared/types/src';

const initialState: AppInfoStateType | WebInfoStateType = {} as AppInfoStateType | WebInfoStateType;

const appInfoSlice = createSlice({
    name: 'appInfoSlice',
    initialState,
    reducers: {
        setAppInfo: (state, action: PayloadAction<AppInfoStateType | WebInfoStateType>) => {
            return action.payload;
        }
    }
});

export const AppInfoActions = appInfoSlice.actions;
export default appInfoSlice.reducer;